import React from 'react';
import classNames from 'classnames';
import RenderByScreenSize from '../../RenderByScreenSize';
import styles from './MarginLabel.css';

function MarginLabel(props) {
  const { value, danger } = props;
  return (
    <RenderByScreenSize
      renderLargeScreen={() => (
        <div
          className={classNames(
            'label',
            [styles.percentLabel],
            danger && styles.percentLabelDanger
          )}
          role="status"
        >
          {value}%
        </div>
      )}
    />
  );
}

export default MarginLabel;
